import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  moduleId: module.id.toString(),
  selector: "my-form-input",
  template: `
    <label [class]="getLabelClass(ngModel)" [attr.aria-label]="getAriaRequired(ngModel)">
        <span>First Name <b>*</b></span>
        <div *ngIf="isPaycorUser">
                <b>{{sharedVar}}</b>    
        </div>
        <input [class]="getInputClass(ngModel)" placeholder="e.g. John" type="text" [ngModel]="sharedVar" (ngModelChange)="change($event)" *ngIf="!isPaycorUser"/>
    </label>
`
})
export class FormInputComponent {
  @Input()
  isPaycorUser: boolean;
  @Input()
  sharedVar: string;
  @Output()
  sharedVarChange = new EventEmitter();

  constructor() {}

  private change(newValue: string) {
    console.log("newValue", newValue);
    this.sharedVar = newValue;
    this.sharedVarChange.emit(newValue);
  }

  private getAriaRequired(input: string): string {
    return input == "" ? "This field is required." : "";
  }

  private getLabelClass(input: string): string {
    return input == "" ? "field-row tooltip-bottom error" : "field-row";
  }

  private getInputClass(input: string): string {
    return input == "" ? "invalid" : "";
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/account/form-input.component.ts